const game = {
  state: {
    gameCategory: null,
    gameProvider: null,
    showOffGameBets: null,
    allGame: null,
    gameRecords: null,
    gameNum: 0,
    isGameReady: false
  },
  mutations: {
    SET_GAME_CATEGORY: (state, gameCategory) => {
      state.gameCategory = gameCategory
    },
    SET_GAME_PROVIDER: (state, gameProvider) => {
      state.gameProvider = gameProvider
    },
    SET_SHOW_OFF_GAME_BETS: (state, showOffGameBets) => {
      state.showOffGameBets = showOffGameBets
    },
    SET_ALL_GAME: (state, games) => {
      state.allGame = games
    },
    SET_GAME_RECORD: (state, history) => {
      state.gameRecords = history
    },
    SET_GAME_NUM: (state, games) => {
      state.gameNum = games
    },
    SET_GAME_READY: (state, value) => { // game 加載完畢才可點擊其他 category or type or provider
      state.isGameReady = value
    }
  }
}

export default game
